"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncomeStatementSectionTypeIterable = exports.BalanceSheetSectionTypeIterable = exports.FinancialStatementTypeIterable = exports.ReportFrequencyIterable = void 0;
// *********************************************
//                BASE ATTRIBUTES
// *********************************************
exports.ReportFrequencyIterable = ['month', 'quarter', 'year'];
// *** Financial Statement Type ***
exports.FinancialStatementTypeIterable = [
    'balanceSheet',
    'incomeStatement',
];
// *** Section Types ***
exports.BalanceSheetSectionTypeIterable = [
    'assets',
    'liabilities',
    'equity',
];
exports.IncomeStatementSectionTypeIterable = [
    'income',
    'expenses',
];
//# sourceMappingURL=FinancialData.js.map